import { render } from "./property-baserecord.vue?vue&type=template&id=2c05cfa9"
import script from "./property-baserecord.js?vue&type=script&lang=js"
export * from "./property-baserecord.js?vue&type=script&lang=js"

import "./property-baserecord.vue?vue&type=style&index=0&id=2c05cfa9&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__